import { _readFile } from 'reactApp/modules/uploading/helpers/fs/readFile';

// startIdx - для чтения не всего файла, а блока байт из него
export const readFileContent = (file: File, startIdx: number, stopIdx: number) =>
    _readFile(new FileReader(), file, startIdx, stopIdx, true);
